// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__34jAU","notes":"Notes_notes__dlRea","note":"Notes_note__13dEV","markdown":"Notes_markdown__3NyAZ"};